import { useTranslation } from 'react-i18next';
import { useLabel } from '@platform/hooks/useLabel';
import { cx } from '@platform/core/lib/cx';
import { workspaceType } from '@platform/navigation';
import { initials } from '../initials';
import type { IOtherWorkspaceCardProps } from './IOtherWorkspaceCardProps';

/**
 * Картка простору, до якого можна попроситися (прототип v4 wsNavGroups «Other workspaces you can request»): плитка кольору типу, назва, тип,
 * «N учасників · M модулів», кнопка «Запросити доступ» або вимкнена «Доступ запитано».
 */
export function OtherWorkspaceCard({ workspace, onRequest }: IOtherWorkspaceCardProps) {
  const { t } = useTranslation();
  const label = useLabel();
  const type = workspaceType(workspace.type);
  const meta = [t('shell.members', { count: workspace.members }), t('shell.modulesCount', { count: workspace.modules })].join(' · ');
  return (
    <div className="wn-card">
      <div className="wn-card__top">
        <span className="wn-card__tile" style={{ background: type.tone }} aria-hidden="true">{initials(workspace.name)}</span>
        <span className="wn-card__titles"><span className="wn-card__name" title={workspace.name}>{workspace.name}</span><span className="wn-card__type">{label(type.label)}</span></span>
      </div>
      <span className="wn-card__meta">{meta}</span>
      <button type="button" className={cx('wn-card__btn wn-card__btn--request', workspace.requested && 'is-requested')} disabled={workspace.requested}
        onClick={() => onRequest(workspace)}>
        {workspace.requested ? t('wsNavigator.requested') : t('wsNavigator.request')}
      </button>
    </div>
  );
}
